// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HF-z","hovered":"IF-z","hoverImage":"JF-z","mainImage":"KF-z","imageNoBackground":"LF-z","fullSizeImage":"MF-z"};